export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";